import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import AppError from './AppError.vue'
import router from './router'
import VueAnalytics from 'vue-analytics'
import VuePageTitle from 'vue-page-title'
import VueLazyLoad from 'vue-lazyload'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n'
import Storage from 'vue-ls';

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-154461436-1',
  router
})

Vue.use(VueLazyLoad)
Vue.use(VueI18n)

Vue.use(Storage, {
    namespace: 'sfa_mem__',
    name: 'memStore',
    storage: 'memory'
});

Vue.use(Object.assign({}, Storage), {
    namespace: 'sfa_local__',
    name: 'localStore',
    storage: 'local'
});

axios.get("/api/organisation", {
      cache: {
        maxAge: 24 * 60 * 60 * 1000, // 24 hour
      },
        timeout: 3000
    })
    .then(function (response) {
      Vue.use(VuePageTitle, {
         prefix: response.data.name + ' - ',
      });

        const i18n = createI18n(response.data.supported_languages);

      new Vue({
            data: {
              configuration: response.data
            },
            vuetify,
            router,
            i18n,
            render: h => h(App)
        }).$mount('#app')
    })
    .catch(function (error) {
        const i18n = createI18n([]);

        new Vue({
                vuetify,
                i18n,
                render: h => h(AppError)
        }).$mount('#app')
    });

function createI18n(supported_languages) {
    const language = resolveLocale(supported_languages);
    axios.defaults.headers.common['Accept-Language'] = language;
    return new VueI18n({
        locale: language,
        fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
        messages: loadLocaleMessages()
    });
}

function resolveLocale(supportedLanguages) {
    const languageInStorage = Vue.localStore.get('language');
    if(languageInStorage != null) {
        return languageInStorage;
    } else {
        const language = navigator.language.split('-')[0]
        if(supportedLanguages.includes(language)) {
            return language;
        }

        if(supportedLanguages.length > 0) {
            return supportedLanguages[0];
        } else {
            return language;
        }
    }
}

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
        const locale = matched[1]
        messages[locale] = locales(key)
    }
})
    return messages
}